/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserWalletDetailPageListRespVo } from './GetUserWalletDetailPageListRespVo';
import {
    GetUserWalletDetailPageListRespVoFromJSON,
    GetUserWalletDetailPageListRespVoFromJSONTyped,
    GetUserWalletDetailPageListRespVoToJSON,
    GetUserWalletDetailPageListRespVoToJSONTyped,
} from './GetUserWalletDetailPageListRespVo';

/**
 * 
 * @export
 * @interface PageDataGetUserWalletDetailPageListRespVo
 */
export interface PageDataGetUserWalletDetailPageListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetUserWalletDetailPageListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetUserWalletDetailPageListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetUserWalletDetailPageListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetUserWalletDetailPageListRespVo>}
     * @memberof PageDataGetUserWalletDetailPageListRespVo
     */
    records?: Array<GetUserWalletDetailPageListRespVo>;
}

/**
 * Check if a given object implements the PageDataGetUserWalletDetailPageListRespVo interface.
 */
export function instanceOfPageDataGetUserWalletDetailPageListRespVo(value: object): value is PageDataGetUserWalletDetailPageListRespVo {
    return true;
}

export function PageDataGetUserWalletDetailPageListRespVoFromJSON(json: any): PageDataGetUserWalletDetailPageListRespVo {
    return PageDataGetUserWalletDetailPageListRespVoFromJSONTyped(json, false);
}

export function PageDataGetUserWalletDetailPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetUserWalletDetailPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetUserWalletDetailPageListRespVoFromJSON)),
    };
}

export function PageDataGetUserWalletDetailPageListRespVoToJSON(json: any): PageDataGetUserWalletDetailPageListRespVo {
    return PageDataGetUserWalletDetailPageListRespVoToJSONTyped(json, false);
}

export function PageDataGetUserWalletDetailPageListRespVoToJSONTyped(value?: PageDataGetUserWalletDetailPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetUserWalletDetailPageListRespVoToJSON)),
    };
}

